<template>
  <splash-screen />
</template>

<script>
import SplashScreen from './core/Components/SplashScreen.vue'

export default {
  name: 'App',
  components: {SplashScreen}
}
</script>
